import { render, staticRenderFns } from "./edit-tag.vue?vue&type=template&id=381a20e8&lang=html&"
import script from "./edit-tag.vue?vue&type=script&lang=js&"
export * from "./edit-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-tag.vue"
export default component.exports